const Vue = require('vue')
import apihelper from './apihelper'
import config from '@/util/config'

export default {
    selectcommunity(p) {
        return apihelper.get("/Common/SelectCommunity", p);
    }
}